import { CommonModule } from "@angular/common";
import { Component, computed, input, OnInit, signal } from "@angular/core";
import { TabsModule } from "primeng/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { LoggerService } from "../../../../../../../shared/services/logger.service";
import { BqInspectionDataService } from "../../../../../../../domains/jobs/services/bq-inspection-data.service";
import { BqStepDataServiceFactory } from "../../../../../../shared/bq-step-data-service/bq-step-data-service-factory";
import { NeedsAttentionItemComponent } from "../../../../../components/needs-attention-item/needs-attention-item.component";
import { AssertionIssuesService, IssueWithDetails } from "../../../../../../../domains/assertionIssues/services/assertion-issues.service";

@Component({
  selector: "needs-attention-tab",
  imports: [CommonModule, TabsModule, NeedsAttentionItemComponent],
  templateUrl: "./needs-attention-tab.component.html",
  styleUrls: ["./needs-attention-tab.component.scss"]
})
export class NeedsAttentionTab implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public bqStepDataServiceFactory: BqStepDataServiceFactory,
    private logger: LoggerService,
    private assertionIssueService: AssertionIssuesService
  ) { }

  bqStep = input.required<string>();

  private bqStepDataService = signal<BqInspectionDataService | null>(null);

  job = computed(() => this.bqStepDataService()?.job());
  lot = computed(() => this.bqStepDataService()?.lot());
  components = computed(() => this.bqStepDataService()?.components() ?? []);
  areas = computed(() => this.bqStepDataService()?.areas() ?? []);
  assertions = computed(() => this.bqStepDataService()?.assertions() ?? []);
  issues = computed(() => this.bqStepDataService()?.assertionIssues() ?? []);

  issuesWithDetails = computed<IssueWithDetails[]>(() =>
    this.issues()
      .map(issue => this.assertionIssueService.createIssueWithDetails(issue, this.assertions(), this.components(), this.areas()))
      .sort((a, b) => a.subtext.localeCompare(b.subtext))
  );


  ngOnInit(): void {
    this.bqStepDataService.set(this.bqStepDataServiceFactory.getService<BqInspectionDataService>(this.bqStep()));
  }

  navToIssue(issueWithDetails: IssueWithDetails) {
    const { issue, assertion, component, area } = issueWithDetails;

    if (!assertion || !component || !area) {
      this.logger.warn(`Failed to navigate to issue: missing assertion, component, or area. IssueId: ${issue.id}, AssertionIdentifier: ${assertion?.identifier}, jobId: ${this.job()?.id}, lotId: ${this.lot()?.id}`);
      return;
    }

    this.router.navigate(["../../area", area.id, "component", component.id, "assertion", assertion.id, "issue", issue.id], {
      relativeTo: this.route,
      queryParams: {
        from: "needs-attention-tab"
      }
    });
  }
}
